export const PrintLabelSheetActions = {
    PRINT_LABEL_SHEET: "PRINT_LABEL_SHEET",
    PRINT_LABEL_SHEET_RESPONSE: "PRINT_LABEL_SHEET_RESPONSE",
    PRINT_LABEL_SHEET_ERROR_RESPONSE: "PRINT_LABEL_SHEET_ERROR_RESPONSE",
    RESET_REQUEST: "RESET_REQUEST"
}


// WEBPACK FOOTER //
// ./src/components/labelSheet/actions/PrintLabelSheetActions.js